// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__pflpu","plus":"styles_plus__tA8KT","key":"styles_key__CLhYy"};